/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Manager_Add_Users_LabelInputs */



/**
* | output |
* | --- |
* | "Extra users (beyond those included)" |
*
* @param {Team_Manager_Add_Users_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_manager_add_users_label = /** @type {((inputs?: Team_Manager_Add_Users_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Manager_Add_Users_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Utilisateurs supplémentaires (en plus de ceux inclus)")
	if (locale === "de") return /** @type {LocalizedString} */ ("Zusätzliche Benutzer (über die enthaltenen hinaus)")
	if (locale === "it") return /** @type {LocalizedString} */ ("Utenti extra (oltre a quelli inclusi)")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Дополнительные пользователи (сверх включённых)")
	if (locale === "es") return /** @type {LocalizedString} */ ("Usuarios adicionales (además de los incluidos)")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("额外用户（不含已包含的用户）")
	if (locale === "ja") return /** @type {LocalizedString} */ ("追加ユーザー (含まれる分を超える数)")
	if (locale === "hi") return /** @type {LocalizedString} */ ("अतिरिक्त उपयोगकर्ता (शामिल के अलावा)")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Utilizadores adicionais (além dos incluídos)")
	return /** @type {LocalizedString} */ ("Extra users (beyond those included)")
});